import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "@fetch/axios";
import { TokenContext } from "@context/TokenContext";
import { useTranslation } from "@hooks/useTranslation";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import Spinner from "@components/Spinner";

const EditarMisDatos = () => {

  const navigate = useNavigate();
  const { translate } = useTranslation();
  const { getToken } = useContext(TokenContext);
  const MySwal = withReactContent(Swal)
  const [user, setUser] = useState(null);
  const [name, setName] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [date, setDate] = useState(null);
  const [phone, setPhone] = useState('');
  const [country, setCountry] = useState(user?.country_id || 142);
  const countries = JSON.parse(localStorage.getItem('countries_arteonu'));
  const { lang } = useContext(LanguageCurrencyContext);
  const [loading, setLoading] = useState(true)

  const guardar = async () => {

    if (!name || !lastname || !email || !phone  || !date) {
      MySwal.fire({
        text: translate('error.field'),
        icon: 'error',
        title: 'Oops...'
      })
      return;
    }

    const birthDate = new Date(date);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    const isBirthdayPassed = m > 0 || (m === 0 && today.getDate() >= birthDate.getDate());
    const realAge = isBirthdayPassed ? age : age - 1;

    if (realAge < 18) {
      MySwal.fire({
        text: translate('login.date_error'),
        icon: 'error',
        title: 'Oops...'
      });
      return;
    }

    try {
      setLoading(false)
      const res = await axios.put(
        "/users/data",
        {
          "name": name,
          "lastname": lastname,
          "country_id": country,
          "phone": phone,
          "email": email,
          'date_birth': date
        },
        {
          headers: { 'Authorization': 'Bearer ' + getToken() }
        }
      );

      setLoading(true);
      if (res.data.errors) {
        MySwal.fire({
          text: res.data.message,
          icon: 'error',
          title: 'Oops...'
        })
      } else {

        let us = {
          'name': res.data.name,
          'lastname': res.data.lastname,
          'email': res.data.email,
          'phone': res.data.phone,
          'country_id': res.data.country_id,
          'affiliation': res.data.affiliation,
          'code_phone': res.data.code_phone,
          'date_birth': res.data.date_birth
        }
        setUser(us)
        localStorage.setItem('user_arteonu', JSON.stringify(us))

        MySwal.fire({
          text: translate('view.myprofile.success'),
          icon: 'success',
        }).finally(() => {
          // if(localStorage.getItem('redirect_arteonu') && localStorage.getItem('redirect_arteonu')!==''){
          //   const redirect = localStorage.getItem('redirect_arteonu')
          //   localStorage.removeItem('redirect_arteonu')
          //   navigate('/' + redirect)
          // }
        })

      }
    } catch (error) {

      MySwal.fire({
        text: error.response.data.message,
        icon: 'error',
        title: 'Oops...'
      })
    }
  }

  useEffect(() => {

    const fetchUsuario = async () => {
      try {

        const storedToken = getToken();

        const response = await axios.get('/users/data?lang=' + lang,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${storedToken}`
            },
          }
        );
        setUser(response.data);
        setName(response.data.name);
        setLastname(response.data.lastname);
        setEmail(response.data.email);
        setPhone(response.data.phone);
        setDate(response.data.date_birth);
        localStorage.setItem('user_arteonu', JSON.stringify(response.data))
      } catch (error) {
        console.error('Error fetching user get', error);
      }
    };


    fetchUsuario()
    
   
  }, []);

  return (
    <>
      {!loading && <Spinner />}

      <div className="PerfilContent pt-tophead">

        <div className={`CategoryTitle PerfilSection`}>
          <ul className="Breadcrumb">
            <li onClick={() => { navigate('/home') }} style={{ cursor: "pointer" }}>Home</li>
            <li onClick={() => { navigate('/mi-perfil') }} style={{ cursor: "pointer" }}>{translate('view.myprofile.my_profile')}</li>
            <li>{translate('view.myprofile.edit_my_profile')}</li>
          </ul>
        </div>

        <div className="grid-title" style={{ display: 'block' }}>

          <h2>{translate('view.myprofile.edit_my_profile')}</h2>

        </div>

        <hr />

        <section className="EditarMisDatos">

          <div className="form-box">

            <div className="form-row">

              <label className="FormData name">

                <em className="RequiredData">{translate('view.myprofile.name')}</em>

                <div className="FormInputLight">
                  <input placeholder={translate('login.nameplacesholder')} value={name} onChange={(e) => { setName(e.target.value) }} />
                </div>

              </label>

              <label className="FormData lastname">

                <em className="RequiredData">{translate('view.myprofile.lastname')}</em>

                <div className="FormInputLight">
                  <input placeholder={translate('login.lastnameplacesholder')} value={lastname} onChange={(e) => { setLastname(e.target.value) }} />
                </div>

              </label>

            </div>


            <div className="form-row">

              <label className="FormData name">

                <em className="RequiredData">{translate('login.date')}</em>

                <div className="FormInputLight">
                  <input disabled={user?.date_birth} type="date" placeholder={translate('login.date')} value={date} onChange={(e) => { setDate(e.target.value) }} />
                </div>

              </label>

              

            </div>

            <div className="form-row">

              <label className="FormData lada">
                <em className="RequiredData">{translate('login.country')} </em>
                <div className="FormInputLight">
                  <select onChange={(e) => {
                    const selectedCountryId = parseInt(e.target.value, 10); // Parse to integer
                    const selectedCountry = countries.find(country => country.id == selectedCountryId);
                    if (selectedCountry) {
                      setCountry(selectedCountry.id); // Assuming you still want to set the country ID
                      setPhone(selectedCountry.phone_code);
                    }
                  }}>
                    {countries &&
                      countries.map((pais) => (
                        <option key={pais.id} value={pais.id}
                          selected={(!country && pais.id === 142) || country == pais.id}
                        >
                          {pais.name}
                        </option>
                      ))}
                  </select>
                  <i className="InputIcon icon-Select"></i>
                </div>
              </label>


              <label className="FormData phone-number">
                <em className="RequiredData">{translate('login.phone')} </em>
                <div className="FormInputLight">
                  <input placeholder="5500000000" onChange={(e) => { setPhone(e.target.value) }} value={phone} />
                </div>
              </label>


            </div>

            <label className="FormData">
              <em className="RequiredData">{translate('view.myprofile.email')} </em>
              <div className="FormInputLight">
                <input placeholder={translate('view.myprofile.email')} onChange={(e) => { setEmail(e.target.value) }} value={email} />
              </div>
            </label>

            <button className="ButtonLightMedium" onClick={() => guardar()}>
              {translate('view.myprofile.store')}
            </button>

          </div>

        </section>

      </div>
    </>
  );
};

export default EditarMisDatos;
